<Modal title="Message the business" actionTitle="Submit" {isLoading} on:close={() => $uiState.activeModal = undefined} on:action={() => apply('interested')}>
    <div class="field">
      <div class="field-body">
        <div class="field">
          <div class="control">
            <textarea
              class="textarea"
              placeholder=""
              rows="10"
              bind:value={message} />
          </div>
        </div>
      </div>
    </div>
  </Modal>
  
  <script lang="ts">
    export let item : PublishedOffer_v1_Doc;
  
    import { uiState } from '../../../../lib/uiState';
    import Modal from 'components/Modal.svelte';
  
    let message : string;
  
    let isLoading = false;
  
    async function apply(status: RequestStatus) {
  
      isLoading = true;
  
      let firebase = window.firebase;
  
      await firebase.functions().httpsCallable('api-request-createrequest')({offerId: item.id, message, status} as CreateRequestParams);
  
      isLoading = false;
  
      $uiState.activeModal = undefined;
    }
  
  </script>